/** Longueur minimale d'un mot de passe de l'espace élève (comme le serveur). */
export const PASSWORD_MIN_LENGTH = 8;

/** Ce qui empêche d'enregistrer un nouveau mot de passe saisi deux fois, sinon `null`. */
export function newPasswordProblem(next: string, confirm: string): string | null {
  if (next.length < PASSWORD_MIN_LENGTH) return `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères.`;
  if (next !== confirm) return 'Les deux mots de passe ne correspondent pas.';
  return null;
}
